import { getCategoryId } from "../../state/modules/category/selectors";
import {
  getAllAppliedRefinements,
  getSearchTerm,
  getSort,
  refreshAdvertisementBeacons,
  sendPlacementOnLoadBeacon,
} from "../../state/modules/search";
import getProductsForPage from "../../state/modules/search/domains/pagination/selectors/getProductsForPage";
import getPageNumber from "../../state/modules/search/domains/pagination/selectors/getPageNumber";
import getSponsoredProducts from "../../state/modules/search/advertising/selectors/getSponsoredProducts";
import getSponsoredProductIds from "../../state/modules/search/advertising/selectors/getSponsoredProductIds";
import { getIsSearchPage } from "../../state/modules/page/selectors";
import getFiltersString from "./getFiltersString";
import makeCriteoRequest from "./makeCriteoRequest";
import shouldRefreshBeacons from "./shouldRefreshBeacons";
import shouldAttemptCriteoRequest from "./shouldAttemptCriteoRequest";

const initialiseAdvertsSdk = async ({ dispatch, getState }) => {
  const state = getState();
  const pageNumber = getPageNumber(state);

  const productsCount = getProductsForPage(state, pageNumber).length;
  const sponsoredProductsCount = getSponsoredProducts(state).length;
  const organicProductsCount = productsCount - sponsoredProductsCount;

  const sponsoredProductIds = getSponsoredProductIds(state);
  const isSorted = !!getSort(state);

  const categoryId = getCategoryId(state);
  const searchTerm = getSearchTerm(state);

  if (!shouldAttemptCriteoRequest({ categoryId, searchTerm })) return;

  const {
    products: sponsoredProducts,
    OnLoadBeacon: onLoadBeacon,
    OnViewBeacon: onViewBeacon,
  } = await makeCriteoRequest({
    pageNumber,
    organicProductsCount,
    categoryId,
    searchTerm,
    filters: getFiltersString(getAllAppliedRefinements(state)),
    sponsoredProductIds,
    isSearchPage: getIsSearchPage(state),
    isSorted,
  });

  if (shouldRefreshBeacons({ sponsoredProductIds, isSorted })) {
    dispatch(
      refreshAdvertisementBeacons({
        sponsoredProducts,
        onLoadBeacon,
        onViewBeacon,
      }),
    );
    dispatch(sendPlacementOnLoadBeacon());
  }
};

export default initialiseAdvertsSdk;
